import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssessCaseService } from '../../../shared/services/assessCase.service';
import { CommonModule } from '@angular/common';
import { IRecordOfChange } from '../../../shared/models/assessCase';
import { SpinnerComponent } from '../spinner/spinner.component';
import { PopupMessageComponent } from '../popup-message/popup-message.component';

@Component({
  selector: 'history',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    PopupMessageComponent
  ],
  templateUrl: './history.component.html',
  styleUrl: './history.component.css'
})
export class HistoryComponent implements OnInit {

  @Input() caseId: string | null = null;
  @Input() showHistory: boolean = false;
  @Output() onClose = new EventEmitter<void>();

  recordOfChanges: IRecordOfChange[] = [];
  messageModal: string | null = null;
  popupMessage: string | null = null;
  loading: boolean = false;

  constructor(
    private assessCaseService: AssessCaseService
  ) {}

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory(): void {
    this.loading = true;
    if (this.caseId) {
      this.assessCaseService.getHistoryByCaseId(this.caseId).subscribe({
        next: (res) => {
          this.loading = false;
          this.recordOfChanges = res;
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
          this.popupMessage = err.message
          this.messageModal = 'unsuccess';
        }
      });
    }
  }

  handleCloseHistory(): void {
    this.onClose.emit();
  }
  
  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
    this.onClose.emit();
  }
}
